import { routes } from '@/app/routing/router'
import { EpicProfileView } from './view'
const currentRoute = routes.epicProfile

const EpicProfileRoute = {
  route: currentRoute,
  view: EpicProfileView,
}

export { currentRoute, EpicProfileRoute }
